<template>
  <span>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1920 1440"
      style="enable-background: new 0 0 1920 1440"
      xml:space="preserve"
    >
      <g id="Color_Selections_1_">
        <g id="White_xA0_Image_1_">
          <image
            style="overflow: visible"
            width="1920"
            height="1440"
            id="White_xA0_Image"
           :xlink:href="booth_image"
          ></image>
        </g>
      </g>
      <g id="Social_Media_Links_1_" @click="addObjectView('CONTACT')">
        <g id="Rectangle_9" v-if="vendor_details.social_links.facebook">
          <g>
            <rect :x="vendor_details.social_links.facebook_x" y="1035" class="st0" width="32" height="32" />
          </g>
        </g>
        <g id="Layer_10_xA0_Image_1_" v-if="vendor_details.social_links.facebook">
          <a href="javascript:;" @click="openLink(vendor_details.social_links.facebook)">
            <image
              style="overflow: visible"
              width="32"
              height="32"
              id="Layer_10_xA0_Image"
              :xlink:href="asset+'facebook_icon.png'"
              :transform="'matrix(1 0 0 1 '+vendor_details.social_links.facebook_x+' 1035)'"
            ></image>
          </a>
        </g>
        <g id="Rectangle_9_copy" v-if="vendor_details.social_links.linkedin">
          <g>
            <rect :x="vendor_details.social_links.linkedin_x" y="1035" class="st0" width="32" height="32" />
          </g>
        </g>
        <g id="Layer_11_xA0_Image_1_" v-if="vendor_details.social_links.linkedin">
          <a href="javascript:;" @click="openLink(vendor_details.social_links.linkedin)">
            <image
              style="overflow: visible"
              width="32"
              height="32"
              id="Layer_11_xA0_Image"
              :xlink:href="asset+'linkedin_icon.png'"
              :transform="'matrix(1 0 0 1 '+vendor_details.social_links.linkedin_x+' 1035)'"
            ></image>
          </a>
        </g>
        <g id="Rectangle_9_copy_2"  v-if="vendor_details.social_links.twitter">
          <g>
            <rect :x="vendor_details.social_links.twitter_x" y="1035" class="st0" width="32" height="32" />
          </g>
        </g>
        <g id="Layer_12_xA0_Image_1_"  v-if="vendor_details.social_links.twitter">
          <a href="javascript:;" @click="openLink(vendor_details.social_links.twitter)">
            <image
              style="overflow: visible"
              width="32"
              height="32"
              id="Layer_12_xA0_Image"
              :xlink:href="asset+'twitter_icon.png'"
              :transform="'matrix(1 0 0 1 '+vendor_details.social_links.twitter_x+' 1035)'"
            ></image>
          </a>
        </g>
        <g id="Rectangle_9_copy_3" v-if="vendor_details.social_links.instagram">
          <g>
            <rect :x="vendor_details.social_links.instagram_x" y="1035" class="st0" width="32" height="32" />
          </g>
        </g>
        <g id="Layer_13_xA0_Image_1_" v-if="vendor_details.social_links.instagram">
          <a href="javascript:;" @click="openLink(vendor_details.social_links.instagram)">
          <image
            style="overflow: visible"
            width="32"
            height="32"
            id="Layer_13_xA0_Image"
            :xlink:href="asset+'instagram_icon.png'"
            :transform="'matrix(1 0 0 1 '+vendor_details.social_links.instagram_x+' 1035)'"
          ></image>
          </a>
        </g>
        <g id="Rectangle_9_copy_4"  v-if="vendor_details.social_links.youtube">
          <g>
            <rect :x="vendor_details.social_links.youtube_x" y="1035" class="st0" width="32" height="32" />
          </g>
        </g>
        <g id="Layer_14_xA0_Image_1_" v-if="vendor_details.social_links.youtube">
          <a href="javascript:;" @click="openLink(vendor_details.social_links.youtube)">
          <image
            style="overflow: visible"
            width="32"
            height="32"
            id="Layer_14_xA0_Image"
            :xlink:href="asset+'youtube_icon.png'"
            :transform="'matrix(1 0 0 1 '+vendor_details.social_links.youtube_x+' 1035)'"
          ></image>
          </a>
        </g>
      </g>
      <g id="Rectangle_6_1_" class="st1" v-if="objects.G5.upload_url" @click="addObjectView('BANNER')">
        <g id="Rectangle_6">
          <g>
            <rect x="1612" y="833" class="st0" width="200" height="370" />
          </g>
        </g>
      </g>
      <g id="Layer_21_xA0_Image_1_" v-if="objects.G5.upload_url" @click="addObjectView('BANNER')">
        <a
          href="javascript:;"
          @click="openLink(objects.G5.link)"
        >
        <image
          style="overflow: visible"
          width="200"
          height="370"
          id="Layer_21_xA0_Image"
          :xlink:href="objects.G5.upload_url"
          transform="matrix(1 0 0 1 1612 833)"
        ></image>
        </a>
      </g>
      <g id="Rectangle_7_1_" class="st1">
        <g id="Rectangle_7">
          <g>
            <rect x="450" y="1020" class="st0_transparent" width="192" height="60" />
          </g>
        </g>
      </g>
      <g id="Layer_22_xA0_Image_1_" @click="addObjectView('CONTACT')">
        <text style="overflow: visible;"
          width="192"
          height="60"
          id="Layer_22_xA0_Image"
          transform="matrix(1 0 0 1 450 1020)"
          fill="white"
          v-html="getContactDetails(objects.G4.contact_details)"
        ></text>
      </g>
      <g id="Rectangle_5_1_" class="st1">
        <g id="Rectangle_5">
          <g>
            <rect x="1402" y="675" class="st0_transparent" width="180" height="180" />
          </g>
        </g>
      </g>
      <g id="Layer_20_xA0_Image_1_" @click="addObjectView('GIVEAWAY')">
        <a href="javascript:;" @click="openLink(objects.G3.link)">
          <image
            style="overflow: visible"
            width="180"
            height="180"
            id="Layer_20_xA0_Image"
            :xlink:href="objects.G3.upload_url"
            transform="matrix(1 0 0 1 1402 675)"
          ></image>
        </a>
      </g>
      <g id="Rectangle_4_1_" class="st1">
        <g id="Rectangle_4">
          <g>
            <rect x="914" y="675" class="st0" width="426" height="240" />
          </g>
        </g>
      </g>
      <g id="Layer_19_xA0_Image_1_" @click="addObjectView('VIDEO')">
        <a href="javascript:;" @click="ShowVideo(objects.G1.link,objects.G1.type)">
          <image
            style="overflow: visible"
            width="426"
            height="240"
            id="Layer_19_xA0_Image"
            :xlink:href="objects.G1.upload_url"
            transform="matrix(1 0 0 1 914 675)"
          ></image>
        </a>
      </g>
      <g id="Rectangle_3_1_" class="st1">
        <g id="Rectangle_3">
          <g>
            <rect x="653" y="675" class="st0" width="200" height="240" />
          </g>
        </g>
      </g>
      <g id="Layer_18_xA0_Image_1_" @click="addObjectView('DESCRIPTION')">
        <a
          href="javascript:;"
          @click="ShowVideo(objects.G6.link, objects.G6.type)"
        >
          <image
            style="overflow: visible"
            width="200"
            height="240"
            id="Layer_18_xA0_Image"
            :xlink:href="objects.G6.upload_url"
            transform="matrix(1 0 0 1 653 675)"
          ></image>
        </a>
      </g>
      <g id="Rectangle_2_1_" class="st1">
        <g id="Rectangle_2">
          <g>
            <rect x="739" y="515" class="st0" width="240" height="48" />
          </g>
        </g>
      </g>
      <g id="Layer_17_xA0_Image_1_" @click="addObjectView('RESOURCE')">
        <a href="javascript:;" @click="openResources(vendor_details.vendor_id)">
          <image
            style="overflow: visible"
            width="240"
            height="48"
            id="Layer_17_xA0_Image"
            :xlink:href="asset+'/res_button.gif'"
            transform="matrix(1 0 0 1 739 515)"
          ></image>
        </a>
      </g>
      <g id="Rectangle_1_1_" class="st1">
        <g id="Rectangle_1">
          <g>
            <rect x="379" y="512" class="st0_transparent" width="334" height="132" />
          </g>
        </g>
      </g>
      <g id="Layer_16_xA0_Image_1_" @click="addObjectView('LOGO')">
        <a
            href="javascript:;"
            @click="openLink(objects.G2.link)"
          >
          <image
            style="overflow: visible"
            width="334"
            height="132"
            id="Layer_16_xA0_Image"
            :xlink:href="objects.G2.upload_url"
            transform="matrix(1 0 0 1 379 512)"
          ></image>
        </a>
      </g>
    </svg>
    <v-dialog v-model="show_preview" max-width="50%">
      <v-card :height="($vuetify.breakpoint.height-250) +'px'">        
          <!-- <video :src="preview_data" width="100%" controls></video> -->
        <iframe frameborder="0" :src="preview_data" width="100%" height="100%"></iframe>  
        <v-btn style="position:absolute;top:10px;right:10px" color="red" dark fab small @click="show_preview = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>             
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_desc_modal" max-width="50%">
      <v-card>
        <v-card-title class="pa-3 pb-1">Company Description</v-card-title>
        <v-card-text class="pa-3 pb-0 rounded-lg">
          {{ vendor_details.comapny_desc }}
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" text @click="show_desc_modal = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ResourcePopup />
  </span>
</template>
<script>
import axios from "@/helper/axios";
import ResourcePopup from "@/components/Resource.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "MainImage",
  components: {
    ResourcePopup,
  },
  data() {
    return {
      loading: false,
      preview_data: null,
      show_preview: false,
      show_desc_modal: false,
      respresentative: [],
      vendor_details: {
        social_links : {
          facebook:"",
          linkedin:"",
          twitter:"",
          instagram:"",
          youtube:"",
          facebook_x:"",
          linkedin_x:"",
          twitter_x:"",
          instagram_x:"",
          youtube_x:"",
        }
      },
      desc_y: 0,
      xb: 693,
      last_xb: 693,
      objects: {
        G1: { upload_url: "" },
        G2: { upload_url: "" },
        G3: { upload_url: process.env.VUE_APP_ASSETS + 'giveaway_image.png' },
        G4: { upload_url: "",contact_details:"" },
        G5: { upload_url: "" },
        G6: { upload_url: "" },
      },
      booth_image: null,
    };
  },
  watch : {
    "vendor_details.social_links.facebook" : function(value){
      if(value){
        this.vendor_details.social_links.facebook_x = this.last_xb
      }
    },
    "vendor_details.social_links.linkedin" : function(value){
      if(value){
        this.vendor_details.social_links.linkedin_x = this.last_xb = this.last_xb+40
      }
    },
    "vendor_details.social_links.twitter" : function(value){
      if(value){
        this.vendor_details.social_links.twitter_x = this.last_xb = this.last_xb+40
      }
    },
    "vendor_details.social_links.instagram" : function(value){
      if(value){
        this.vendor_details.social_links.instagram_x = this.last_xb = this.last_xb+40
      }
    },
    "vendor_details.social_links.youtube" : function(value){
      if(value){
        this.vendor_details.social_links.youtube_x = this.last_xb = this.last_xb+40
      }
    },
    show_preview : function(value){
      if(!value){
       this.preview_data = null
      }
    }
  },
  computed: {
    ...mapState("utils", ["maxWidth"]),
    ...mapState("resource", ["resource_vendor_id", "resource_start_from"]),
    asset() {
      return process.env.VUE_APP_ASSETS;
    },
    intro_video_thumb() {
      return process.env.VUE_APP_ASSETS + "intro_video_thumb.png";
    },
  },
  methods: {
    ...mapMutations("resource", ["setResourceData"]),
    addObjectView(type) {
      let _self = this;
      axios
        .post("/object/add_view",{type: type, vendor_id: this.$route.params.vendor_id})
        .then(function () {
          
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    openLink(href) {
      if (href) {
        Object.assign(document.createElement("a"), {
          target: "_blank",
          href,
        }).click();
      }
    },
    getContactDetails(details) {
      let contact_arr = details.split("\n");
      let x = 10;
      let y = 18;
      let svgTextHtml = ``;
      for (let i = 0; i <= contact_arr.length - 1; i++) {
        svgTextHtml += `<tspan x="${x}" y="${y}">${contact_arr[i]}</tspan>`;
        y = y + 18;
      }
      return svgTextHtml;
    },
    getDescription(description) {
      let svgTextLength = Math.round(description.length / 20);
      let svgTextHtml = ``;
      let x = 5;
      let y = 20;
      let diff = 24;
      let startFrom = 0;
      let endFrom = diff;
      for (let i = 1; i <= svgTextLength; i++) {
        if (i < 11) {
          var res = description.substring(startFrom, endFrom);
          svgTextHtml += `<tspan x="${x}" y="${y}">${res}</tspan>`;
          y = y + 20;
          startFrom = startFrom + diff;
          endFrom = endFrom + diff;
        }
      }
      this.desc_y = y;
      return svgTextHtml;
    },
    isShowReadMore(description) {
      return Math.round(description.length / 20) > 12;
    },
    openResources(vendor_id) {
      this.setResourceData({
        key: "show_resource_modal",
        data: true,
      });
      this.setResourceData({
        key: "resource_vendor_id",
        data: vendor_id,
      });
    },
    getBoothsDetails() {
      let _self = this;
      axios
        .get("/vendor/details?vendor_id=" + this.$route.params.vendor_id)
        .then(function (response) {
          let vendor_data = response.data.data;
          _self.vendor_details = vendor_data;
          for (let key in vendor_data.object_data) {
            let data = vendor_data.object_data[key];
            _self.objects[data.position_data.position] = data;
          }
          let b_color = (_self.vendor_details.booth_color!=null)?_self.vendor_details.booth_color:'white';
          _self.booth_image = process.env.VUE_APP_ASSETS+"booth/gold/" +b_color+".png";
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    openBoothDetails(vendor_id) {
      this.$router.push("/vendor/" + vendor_id);
    },
    ShowVideo(video_src, type) {
      type;
      // if (type == "VIDEO") {
        this.show_preview = true;
        this.preview_data = video_src;
      // }
    },
  },
  mounted() {
    this.loading = true;
    this.getBoothsDetails();
  },
};
</script>
<style type="text/css">
.st0 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #00000069 !important;
}
.st0_transparent{
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #0db04b00;
}
.st0_contact {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #727272;
}
.st1 {
  enable-background: new;
}
</style>